export const StatusActiveInactive = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}

export const StatusActiveInactiveClassname = {
    ACTIVE: "active",
    INACTIVE: "inactive"
}